import type { FieldMergeFunction } from '@apollo/client/core';
import type {
    Edge,
    PageInfo,
} from '@precon-tools-suite-by-shared/precon-graphql-types';

export const pageInfoMerger: FieldMergeFunction<Partial<PageInfo>> = (
    existing,
    incoming,
    { mergeObjects }
) => {
    return {
        ...mergeObjects(existing ?? {}, incoming),
        startCursor: existing?.startCursor,
        endCursor: incoming.endCursor ?? existing?.endCursor ?? null,
    };
};

export const edgeMerger: FieldMergeFunction<Partial<Edge>> = (
    existing,
    incoming,
    { mergeObjects }
): Partial<Edge> => {
    return {
        ...mergeObjects(existing ?? {}, incoming),
        cursor: existing?.cursor ?? incoming.cursor,
    };
};

export const edgesMerger: FieldMergeFunction<Partial<Edge>[]> = (
    existing,
    incoming,
    { mergeObjects, readField }
) => {
    if (!existing) return incoming;
    const inMap = new Map(
        incoming?.map((e) => [readField<any>('cursor', e), e])
    );
    const result: Partial<Edge>[] = [];
    // Inserting the existing edges.
    for (const edge of existing) {
        const cursor = readField('cursor', edge);
        if (cursor && inMap.has(cursor)) {
            result.push(mergeObjects(edge, inMap.get(cursor) ?? {}));
            inMap.delete(cursor);
        } else {
            result.push(edge);
        }
    }

    // Inserting the incoming edges.
    if (incoming) {
        for (const edge of incoming) {
            const cursor = readField('cursor', edge);
            if (!cursor || inMap.has(cursor)) {
                result.push(edge);
            }
        }
    }
    return result;
};
